import { transactions } from './transactions';
import { blocks } from './blocks';

const models = {
  transactions,
  blocks,
};

export default models;
